export const BILLING_SORT_BY_TYPE = {
    DATE: 'date',
    NUMBER: 'number',
    TRANSFERRED: 'transferred',
    TOTAL_AMOUNT: 'totalAmount',
};
